import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { InsuranceProgramFragment } from '@websky/graphql';
import { ServiceOptionItem } from '../../../../ServiceSummary/types';
import { ThemeProvider, useTheme } from '../../../../theme';
import CheckoutAdditionalService from '../../../../CheckoutAdditionalService';
import ServiceSummaryOption from '../../../../ServiceSummary/components/ServiceSummaryOption';
import { addMoney } from '@shared/lib/money';
import Money from '../../../../Money';
import { Money as MoneyType } from '../../../../Money/types';

interface Props {
	services: InsuranceProgramFragment[];
}

const InsuranceRefundCard: React.FC<Props> = props => {
	const { t } = useTranslation('Checkout');
	const { CommonContent: theme } = useTheme('RefundSummary');

	const { items, totalPrice } = React.useMemo(() => {
		const items: ServiceOptionItem[] = [];
		let totalPrice: MoneyType = {
			currency: props.services[0].totalPrice.currency,
			amount: 0
		};

		props.services.forEach(service => {
			items.push({
				id: service.code,
				name: service.name,
				price: service.totalPrice
			});

			totalPrice = addMoney(totalPrice, service.totalPrice);
		});

		return { items, totalPrice };
	}, [props.services]);

	return (
		<CheckoutAdditionalService
			header={t('Insurance')}
			description={t('Transportation of impressions no limitations')}
			className={cn(theme.serviceCard, theme.serviceCard_insurance)}
			isSelected={true}
			addClick={() => null}
		>
			<ThemeProvider
				value={{
					ServiceSummary: {
						ServiceSummaryOption: {
							option__price: theme.price
						}
					}
				}}
			>
				<ServiceSummaryOption groupOption={{ items }} />
			</ThemeProvider>
			<div className={theme.totalRefund}>
				{t('Refund')}: <Money money={totalPrice} />
			</div>
		</CheckoutAdditionalService>
	);
};

export default InsuranceRefundCard;
